<template>
  <v-card>
    <loading
      slot="activator"
      :active.sync="isLoadingOrSaving"
      :can-cancel="false"
      loader="dots"
      :color="appColor_Progress"
    />
    <template v-if="customers.length === 0 && !isLoading">
      <h1 class="font-weight-light">
        No customers found
      </h1>
    </template>
    <template v-else>

      <!-- Header Toolbar -->
      <v-toolbar
        dark
        flat
        :color="appColor_Medium"
        >

        <!-- Cancel -->
        <v-btn
          icon
          dark
          @click="cancel"
          class="elevation-0"
          >
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title>{{ selectedCustomer }}</v-toolbar-title>

        <v-spacer />
        
        <!-- OK -->
        <v-toolbar-items>
          <v-btn
            :disabled="selected.length === 0 || isSaving"
            :loading="isSaving"
            dark
            :color="appColor_Medium"
            @click="select"
            class="elevation-0"
            >
            OK
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <!-- Search Text -->
      <v-list-item>
        <v-card-text>
          <v-text-field
            v-model="search"
            class="pt-0 pb-0"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-text>
      </v-list-item>

      <!-- Data Table -->
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="customers"
        :loading="isLoading"
        :search="search"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :footer-props="{'items-per-page-options': [10]}"
        show-select
        single-select
        item-key="accountNo"
        >
        <v-progress-linear
          v-slot:progress
          :color="appColor_Progress"
          indeterminate
        />
      </v-data-table>
    </template>

    <!-- Error Dialog -->
    <v-dialog
      v-model="errorDialog"
      max-width="400px"
      >
      <v-card>
        <v-card-title color="red darken-2">
          <span class="title font-weight-regular"><v-icon
            dark
            class="mr-2"
          >error</v-icon> Internal Error</span>
        </v-card-title>
        <v-card-text>
          <p> {{ errorText }} </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-4"
            flat
            @click.native="errorDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import appService from '@/app.service'
import { AppColor  } from '@/config.js'

export default {
  name: 'BbCustomerSelector',
  props: {
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      appColor_Medium: AppColor.Medium,
      appColor_Progress: AppColor.Progress,

      isLoading: true,
      isError: false,
      errorDialog: false,
      errorText: '',
      selected: [],
      customers: [],
      search: '',
      sortBy: 'contactName',
      sortDesc: false,
      headers: [
        {
          text: 'Contact Name',
          value: 'contactName',
          align: 'left',
          width: '20%'
        },
        {
          text: 'Company',
          value: 'company',
          align: 'left',
          width: '25%'
        },
        {
          text: 'City',
          value: 'city',
          align: 'left',
          width: '15%'
        },
        {
          text: 'State',
          value: 'state',
          align: 'left',
          width: '5%'
        },
        {
          text: 'Postal',
          value: 'postalCode',
          align: 'left',
          width: '15%'
        },
        {
          text: 'Phone',
          value: 'phone1',
          align: 'left',
          width: '20%'
        }
      ]
    }
  },
  computed: {
    selectedCustomer () {
      if (this.selected.length > 0) {
        return this.selected[0].contactName
      }
      return 'Select Customer'
    },
    isLoadingOrSaving () {
      return this.isLoading || this.isSaving
    }
  },
  methods: {
    loadData () {
      const self = this
      self.isLoading = true
      self.isError = false
      appService.getBeefboosterCustomers().then(data => {
        if (data.errorSeverity > 0) {
          self.isError = true
          self.errorText = '<v-flex class="text-xs-left">' + data.errorMessage + '</v-flex>'
          self.errorDialog = true
        } else {
          self.customers = data.customers
        }
        self.isLoading = false
      })
    },

    select () {
      this.isLoading = true
      const sel = this.selected[0]
      this.$emit('select', { account: {
        accountNo: sel.accountNo,
        isBreeder: sel.isBreeder,
        contactName: sel.contactName,
        companyName: sel.company,
        phone1: sel.phone1,
        phone2: sel.phone2,
        herdSns: sel.herdSns
      }})
    },

    cancel () {
      this.$emit('cancel')
      this.reset ()
    },

    reset () {
      const self = this
      setTimeout(() => {
        self.search = ''
        self.isLoading = false
        self.selected = []
        self.sortBy = 'contactName'
        self.sortDesc = false
      }, 300)
    }
  },
  watch: {
    isSaving (value) {
      if (value === null) return
      if (!value) this.reset()
    }
  },
  created () {
    this.loadData()
  }
}
</script>
